import frac from '../../assets/latex/frac.svg';
import sqrt from '../../assets/latex/sqrt.svg';
import root from '../../assets/latex/root.svg';
import sum from '../../assets/latex/sum.svg';
import bracket from '../../assets/latex/bracket.svg';
import braces from '../../assets/latex/braces.svg';
import round_brackets from '../../assets/latex/round_brackets.svg';
import complement from '../../assets/latex/complement.svg';
import complementu from '../../assets/latex/complementu.svg';
import square from '../../assets/latex/square.svg';
import modulus from '../../assets/latex/modulus.svg';
import lefttsrightm from '../../assets/latex/lefttsrightm.svg';
import lefttmrights from '../../assets/latex/lefttmrights.svg';
import leftrightm from '../../assets/latex/leftrightm.svg';
import leftrights from '../../assets/latex/leftrights.svg';
import exponentn from '../../assets/latex/sup.svg';
import cube from '../../assets/latex/cube.svg';
import cube_root from '../../assets/latex/cube_root.svg';
import centigrade from '../../assets/latex/centigrade.svg';
import fahrenheit from '../../assets/latex/fahrenheit.svg';
import r_subscript from '../../assets/latex/r_subscript.svg';
import xrightarrow_chemical from '../../assets/latex/xrightarrow_chemical.svg';
import xrightleftharpoons_chemical from '../../assets/latex/xrightleftharpoons_chemical.svg';
import xlongequal_chemical from '../../assets/latex/xlongequal_chemical.svg';
import equation from '../../assets/latex/equation.svg';
import ternary_equations from '../../assets/latex/ternary_equations.svg';
import binary_equations from '../../assets/latex/binary_equations.svg';
import quaternion_equations from '../../assets/latex/quaternion_equations.svg';
import oversetfrown from '../../assets/latex/oversetfrown.svg';
import cong from '../../assets/latex/cong.svg';
import sim from '../../assets/latex/sim.svg';
import simeq from '../../assets/latex/simeq.svg';
import sub_sup from '../../assets/latex/sub_sup.svg';
import dotx from '../../assets/latex/dotx.svg';
import overrightarrow from '../../assets/latex/overrightarrow.svg';
import overleftrightarrow from '../../assets/latex/overleftrightarrow.svg';
import overline from '../../assets/latex/overline.svg';
import pm from '../../assets/latex/pm.svg';
import cdot from '../../assets/latex/cdot.svg';
import l_subsupscript from '../../assets/latex/l_subsupscript.svg';
import l_sup from '../../assets/latex/l_sup.svg';
import l_subscript from '../../assets/latex/l_sub.svg';
import r_subsupscript from '../../assets/latex/r_subsupscript.svg';

const LatexIcons = {
    frac: frac,
    sqrt: sqrt,
    sum: sum,
    bracket: bracket,
    braces: braces,
    round_brackets: round_brackets,
    complement: complement,
    complementu: complementu,
    square: square,
    modulus: modulus,
    lefttsrightm: lefttsrightm,
    lefttmrights: lefttmrights,
    leftrightm: leftrightm,
    leftrights: leftrights,
    exponentn: exponentn,
    sup: exponentn,
    cube: cube,
    root: root,
    cube_root: cube_root,
    centigrade: centigrade,
    fahrenheit: fahrenheit,
    r_subscript: r_subscript,
    xrightarrow_chemical: xrightarrow_chemical,
    xrightleftharpoons_chemical: xrightleftharpoons_chemical,
    xlongequal_chemical: xlongequal_chemical,
    ternary_equations: ternary_equations,
    binary_equations: binary_equations,
    quaternion_equations: quaternion_equations,
    equation: equation,
    oversetfrown: oversetfrown,
    cong: cong,
    sim: sim,
    simeq: simeq,
    sub_sup: sub_sup,
    dotx: dotx,
    overrightarrow: overrightarrow,
    overleftrightarrow: overleftrightarrow,
    overline: overline,
    plus_minus: pm,
    cdot: cdot,
    l_subsupscript: l_subsupscript,
    l_sup: l_sup,
    l_subscript: l_subscript,
    r_subsupscript: r_subsupscript
  }
  
  export default LatexIcons;